import { Button } from 'antd';
import React, { useMemo} from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css'
import {allowPermission} from "../../../../utils/permission";

interface props {
  enums?: any
  enumsName?: any
  current?:any
  permission?:any
  authStatus?: any
}

const SPContent: React.FC<props> = (props) => {
  const { permission, authStatus } = props
  const navigate = useNavigate();
  const list = [
    {
      logo: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/mendian.png',
      name: '创建门店',
      btn: '点击创建',
      disabled: true,
      type: 'creatStore',
      permissionCode: '/storeManagement/StoreList',
      navigate: () => navigate('/storeManagement/StoreList'),
    },
    {
      logo: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/upload-car.png',
      name: '上传车辆',
      btn: '点击上传',
      disabled: true,
      type: 'uploadCar',
      permissionCode: '/vehicleManagement/Vehicle',
      navigate: () => navigate('/vehicleManagement/Vehicle'),
    },
    {
      logo: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/setting-employee.png',
      name: '完善员工',
      btn: '点击完善',
      disabled: true,
      desc: '未入网不可操作',
      permissionCode: '/employeeManagement/EmployeeList',
      navigate: () => navigate('/employeeManagement/EmployeeList'),
    },
    {
      logo: 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/seting-goods-price.png',
      name: '配置商品及定价',
      btn: '点击完善',
      disabled: true,
      desc: '未入网不可操作',
      permissionCode: '/product-price/car-model-price',
      navigate: () => navigate('/product-price/car-model-price'),
    },
  ]


  const calcList = useMemo(() => {
    return list.map((item) => {
      return {
        ...item,
        disabled: !allowPermission(item.permissionCode, permission),
        desc: !allowPermission(item.permissionCode, permission) ? '未入网不可操作' : ''
      }
    })
  }, [permission]);


  return <div className="SPEntryHomeSPContent">
    <div className='title'>{authStatus?.seal_status === 1 ? '你已完成上述流程，可以进行下列系统配置' : '您也可以先进行系统配置'}</div>
    <div className='box'>
      {
        calcList.map((item: any, index: number) => {
          return (
              <>
                <div className='item' onClick={() => item.navigate()}>
                  <div className='logo-bg'>
                    <img className='logo' src={item.logo} alt={item.name}/>
                  </div>
                  <div className='name'>
                    {item.name}
                  </div>
                  <Button type='primary' disabled={item.disabled} className='btn'>
                    {item.btn}
                  </Button>
                  {
                    item.desc ?
                        <div className='desc'>
                          {item.desc}
                        </div> : null
                  }
                </div>
                {
                  index < list.length - 1 ?
                      <div className="zhanwei">
                        <img className='img' src="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/arrow-line.png"
                             alt=""/>
                      </div>
                      : null
                }
              </>
          )
        })
      }

    </div>
  </div>
};

export default SPContent;
